import React, { useState, useCallback } from "react";
import { Link } from "gatsby";
import styled from 'styled-components';
import Img from 'gatsby-image';
// import { GatsbyImage } from "gatsby-plugin-image"
import { rhythm } from "../utils/typography";
import EmojiWrapper from './EmojiWrapper';

const InnerDiv = styled.div`
  display:inline-flex;
  align-items:center;
  width:100%;
  padding:${rhythm(0.75)};
  min-width:250px;
  
  @media only screen and (max-width: 550px) {
    min-width:100%;
    width:100%;
  }

  
`
const BlogDiv = styled.div`
display:block;
position:relative;
&:before {
  border-radius: 30px;
  content:"";
  display:block;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);
  width:calc(100% - ${rhythm(0.75)});
  height:calc(100% - ${rhythm(0.75)});
  opacity:0;
  transition: width 0.20s cubic-bezier(.4,0,.59,1), height 0.20s cubic-bezier(.4,0,.59,1), opacity 0.18s cubic-bezier(.4,0,.59,1);
  background:var(--color-foreground);
}
:hover{
  &:before{
    opacity:1;
    width:100%;
    height:100%;
  }
}
`;
const DetailsDiv = styled.div`
  position:relative;
  width:100%;
  min-width: 250px;
  flex:3;
  height:fit-content;
  padding: 0 ${rhythm(0.25)};
  @media only screen and (max-width: 550px) {
    min-width:100%;
    width:100%;
  }
`;


const ImageDiv = styled.div`
  flex:1;
  min-width:200px;
  margin-right:2ch;
  width:200px;
  height:200px;
  border-radius: 16px;
  overflow:hidden;
  position:relative;
  box-shadow: 0 6px 12px 0 rgba(0,0,0,0.04); 

  @media only screen and (max-width: 550px) {
    display:none;
      img{
       display:none;
      }
    }
  }
  &:after{
    content:"›";
    display:block;
    width:24px;
    height:24px;
    font-size:1rem;
    font-weight:bolder;
    line-height:1rem;
    text-align:center;
    border-radius:50%;
    background:var(--color-background);
    color:var(--color-secondary);
    position:absolute;
    top:50%;
    left:${({ isHovered }) => isHovered ? '50%' : '45%'};
    transform:translate(-50%, -50%);
    opacity:${({ isHovered }) => isHovered ? '1' : '0'};
    transition: left 0.20s cubic-bezier(.4,0,.59,1), opacity 0.18s cubic-bezier(.4,0,.59,1);
  }
`;



const ImageComponent = ({
  fixed,
  isHovered
}) => {

  const imageStyle = {
    objectFit: 'contain',
    // ...imageDivSpringStyle
    width: isHovered ? '200px' : '220px',
    height: isHovered ? '200px' : '220px',
    top: isHovered ? '0px' : '-10px',
    left: isHovered ? '0px' : '-10px',
    right: isHovered ? '0px' : '-10px',
    bottom: isHovered ? '0px' : '-10px',
    filter: isHovered ? 'grayscale(0%)' : 'grayscale(100%)',
    transition: 'all 0.18s cubic-bezier(.4,0,.59,1)',
  }

  return (
    <ImageDiv isHovered={isHovered}>
      <Img fixed={fixed} imgStyle={imageStyle} />
    </ImageDiv>
  )
}

const ContainerComponent = ({ frontMatter, i, slug, featuredImageFixed, post }) => {
  const [isHovered, setIsHovered] = useState(false);

  const enterTrigger = useCallback(() => {
    setIsHovered(true);
  }, []);

  const leaveTrigger = useCallback(() => {
    setIsHovered(false);
  }, []);


  return (
    <div
      onMouseEnter={enterTrigger}
      onMouseLeave={leaveTrigger}
      style={{ marginBottom: rhythm(1.5), width: '100%' }}>
      <Link to={slug} >
        <BlogDiv>
          <InnerDiv>
            <ImageComponent
              fixed={featuredImageFixed}
              isHovered={isHovered}
            />
            <DetailsDiv>
              <small style={{ color: 'var(--color-gray1)' }}>
                <EmojiWrapper emoji="🕓" name="time to read" /> {post.node.timeToRead}min. read
              </small>
              <strong style={{
                marginTop: 4,
                display: 'block',
                fontWeight:"bold",
                fontSize: '1.5rem',
                lineHeight: 1,
                color: 'var(--color-headingFont)'
              }}
              >
                {frontMatter.title}
              </strong>
              <small style={{ marginTop:0 }}>{frontMatter.caption}</small>
              <p style={{ fontSize: '0.9rem', marginTop:"8px", color: isHovered ? 'var(--color-gray1)' :'var(--color-gray2)' }}>{post.node.excerpt}</p>
            </DetailsDiv>
          </InnerDiv>
        </BlogDiv>
      </Link>
    </div>
  )
}

const BlogPreview = ({ posts }) => {
  return (
    posts.map((post, i) => {
      const slug = post.node.fields.slug;
      const frontMatter = post.node.frontmatter;
      const featuredImageFixed = frontMatter.featuredImage.childImageSharp.fixed;

      return (
        <ContainerComponent
          key={slug}
          frontMatter={frontMatter}
          post={post}
          featuredImageFixed={featuredImageFixed}
          slug={slug}
        />
      );
    })
  )
};

export default BlogPreview;